/*
 * - Definitions of PublicNotice queries
 */

import PublicNoticeService from './service';
import {
  ExportPublicNoticeCsvData,
  ExportPublicNoticeCsvRequest,
  SavePublicNoticeCommentRequest,
  SavePublicNoticeCommentResponse,
} from './types';

export class PublicNoticeMutations {
  public static readonly saveComment = async (
    payload: SavePublicNoticeCommentRequest
  ): Promise<SavePublicNoticeCommentResponse> => {
    const response = await PublicNoticeService.saveComment(payload);

    return response;
  };

  public static readonly exportAllAsCsv = async (
    filters: ExportPublicNoticeCsvRequest
  ): Promise<ExportPublicNoticeCsvData> => {
    const { data } = await PublicNoticeService.exportAllAsCsv(filters);

    return data;
  };
}
